import React from "react";
import { logo } from "./preloadLogo";

export interface WirderMarkProps {
  className?: string;
  alt?: string;
}

/** The Wirder bluebird mascot. The `.appbar__logo` / screen classes apply the
 *  horizontal mirror so the bird faces into the screen. */
export function WirderMark({ className, alt = "" }: WirderMarkProps) {
  return <img src={logo} className={className} alt={alt} draggable={false} />;
}
